import React from "react";
import Ballon from "../../../../components/inputs/ballon";
import DateInput from "../../../../components/inputs/dateInput";
import TextInput from "../../../../components/inputs/textInput";
const OPTIONS = {
  types: [
    {
      title: "نوع 1",
      id: "Type1",
    },
    {
      title: "نوع 2",
      id: "Type2",
    },
  ],
  pattern1: [
    {
      title: "فروش",
      id: "Sale",
    },
    {
      title: "فروش ارزی",
      id: "CurrSale",
    },
    {
      title: "طلا، جواهر و پلاتین",
      id: "Jewelry",
    },
    {
      title: "قرارداد پیمانکاری",
      id: "Contract",
    },
    {
      title: "قبوض خدماتی",
      id: "Service",
    },
    {
      title: "بلیت هواپیما",
      id: "Airfare",
    },
    {
      title: "صادرات",
      id: "Export",
    },
  ],
  pattern2: [
    {
      title: "فروش",
      id: "Sale",
    },

    {
      title: "طلا، جواهر و پلاتین",
      id: "Jewelry",
    },
  ],
  paymentType: [
    {
      title: "نقد",
      id: "Cash",
    },
    {
      title: "نسیه",
      id: "Credit",
    },
    {
      title: "نقد/نسیه",
      id: "CashCredit",
    },
  ],
};
const StepType = ({ data, setData }) => {
  return (
    <div className="flex flex-col gap-4 relative z-50">
      <Ballon
        label={"نوع صورتحساب"}
        options={OPTIONS.types}
        value={data.chInvoiceTypeCode}
        onChange={(e) => {
          if (e === "Type2") {
            if (data.chInvoicePatternCode !== "Jewelry") {
              setData({
                ...data,
                chInvoiceTypeCode: e,
                chInvoicePatternCode: "Sale",
              });
            } else {
              setData({ ...data, chInvoiceTypeCode: e });
            }
          } else {
            setData({ ...data, chInvoiceTypeCode: e });
          }
        }}
      />
      <Ballon
        label={" الگوی صورتحساب"}
        options={
          data.chInvoiceTypeCode === "Type2"
            ? OPTIONS.pattern2
            : OPTIONS.pattern1
        }
        value={data.chInvoicePatternCode}
        onChange={(e) => setData({ ...data, chInvoicePatternCode: e })}
      />
      <Ballon
        label={"روش تسویه "}
        options={OPTIONS.paymentType}
        value={data.chSettlementMethodCode}
        onChange={(e) => setData({ ...data, chSettlementMethodCode: e })}
      />
      <div className="grid relative grid-cols-2 gap-4 pb-5">
        <TextInput
          label="شماره"
          onChange={(e) => setData({ ...data, chSaleSoftID: e })}
          value={data.chSaleSoftID}
        />
        <DateInput
          label="تاریخ ثبت"
          onChange={(e) => setData({ ...data, dInvoiceDate: e })}
          value={data.dInvoiceDate}
          possition="bottom"
        />{" "}
      </div>
    </div>
  );
};

export default StepType;
